import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { CreateOpportunityYear, DeleteOpportunityYear, GetAllOpportunitiesMapping } from "../../API/OpportunityMappingAPI";
import { handleUploadProjectAPI, handleDownloadProjectModelAPI } from "../../API/ProjectsAPI";
import { handleUploadProjectHistoryAPI, handleDownloadProjectHistoryModelAPI } from "../../API/ProjectHistoryAPI";
import { AuthContext } from "../../Contexts/AuthContext";
import { CompanyContext } from "../../Contexts/CompanyContext";
import { OpportunityMappingModel } from "../../Models/OpportunityMappingModel";
import { SortDesc, SortYear } from "../../Utils/SortYear";
import { IResponseProps } from "../../Interfaces/IResponseProps";
import CardHeader from "../../antd/components/CardHeader";
import Loader from "../../Components/Shared/Loader";
import ModalSelectYear from "../../Components/Shared/ModalSelectYear";
import PaginationTabHeader from "../../Components/Shared/PaginationTabHeader";
import useCreate from "../../Hooks/useCreate";
import useLoading from "../../Hooks/useLoading";
import useModal from "../../Hooks/useModal";
import ProjectComponent from "../../Components/ProjectInformations/ProjectsComponent";
import ProjectHistoryComponent from "../../Components/ProjectInformations/ProjectHistoryComponent"
import './styles.css';
import useCan from "../../Hooks/useCan";
import { Box, Modal, Typography } from "@mui/material";
import { getAllProjectsByCompanyAndYear } from "../../API/ProjectsAPI";
import TablePaginationFooter from "../../Components/Shared/TableDefault/Pagination";
import { ProjectModel } from "../../Models/ProjectModel";
import { IoCodeSlash } from "react-icons/io5";
import { SetFileName } from "../../Utils/SetFileName";
import { UploadModal } from "../../antd/components/UploadModal";
import { Button } from 'antd';
import { CloudDownloadOutlined, CloudUploadOutlined, PlusCircleOutlined } from "@ant-design/icons";


// const style = {
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: '50%',
//     bgcolor: 'background.paper',
//     border: '2px solid #000',
//     boxShadow: 24,
//     p: 4,
// };


const ProjectInformations = () => {
    const [type, setType] = useState<number>();


    const canNotSee = useCan({ rolesCan: ["Internal"] })
    const [file, setFile] = useState<Blob>();
    const { loading, toggleLoading } = useLoading();
    const { showModal, toggleShowModal } = useModal();
    const { showModal: isShowingExcelModal, toggleShowModal: toggleExcelModal } = useModal();
    const { isCreate, toggleIsCreate } = useCreate();
    const [pag, setPag] = useState<number>(0);
    const [years, setYears] = useState<any[]>([]);
    const [opportunityMap, setOpportunityMap] = useState<OpportunityMappingModel[]>([]);
    const [opportunity, setOpportunity] = useState<OpportunityMappingModel>();
    const [year, setYear] = useState<string>("");
    const [key, setKey] = useState<number>(0);
    const [hasChanged, setHasChanged] = useState<boolean>(true);
    const { company } = useContext(CompanyContext);
    const { userEmail } = useContext(AuthContext);
    const [open, setOpen] = useState(false);
    const [projects, setProjects] = useState<ProjectModel[]>([]);
    const [total, setTotal] = useState(0);
    const [modalOpen, setModalOpen] = useState(false);
    const i = years.length
    const isItVisible = SortDesc(years)[pag] !== years[i - 2];

    const fetchProjects = async (page: number) => {
        try {
            const response = await getAllProjectsByCompanyAndYear(company.id, SortDesc(years)[pag + 1], page, 5);
            setProjects(response.data.items);
            setTotal(response.data.total);
        } catch (error) {
            console.error(error);

        }
    };
    const handleOpen = () => {
        setOpen(true);
        setModalOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    useEffect(() => {
        if (modalOpen) {
            fetchProjects(1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalOpen]);

    const createYear = async () => {
        try {
            toggleLoading(true);
            await CreateOpportunityYear(year, company.id, userEmail).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setYear("");
                    getAllOpportunities();
                }
            }).finally(() => {
                toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }


    const deleteYear = async () => {
        try {
            toggleLoading(true);
            await DeleteOpportunityYear(year, company.id).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setYear("");
                    getAllOpportunities();
                    setPag(0);
                }
            }).finally(() => {
                toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const getAllOpportunities = async () => {
        try {
            toggleLoading(true);
            await GetAllOpportunitiesMapping(company.id).then((resp: IResponseProps) => {
                if (resp.data.length === 0) {
                    setYears([]);
                }
                setOpportunityMap(resp.data);
            }).finally(() => {
                setHasChanged(false);
                toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const getYears = () => {
        toggleLoading(true);

        var data = SortYear(opportunityMap);

        var yearsCreatedArray: any[] = [];

        data.map((a: OpportunityMappingModel) => {
            yearsCreatedArray.push(a.year);
            return null
        });

        yearsCreatedArray.push("Histórico De Projetos");

        setYears(yearsCreatedArray);

        toggleLoading(false);
    }

    const updateAllValues = () => {
        var yearsDesc = SortDesc(years);
        var opport = opportunityMap.find((op: any) => op.year === yearsDesc[pag]);

        setOpportunity(opport);
    }
    async function handleUploadProjectInformations(file: Blob[]) {
        try {
            toggleLoading(true);
            toggleExcelModal();
            if (file.length > 0 && opportunity !== undefined && type !== undefined) {
                await handleUploadProjectAPI(file[0], company.id, opportunity.id, userEmail, type, false).then((resp: IResponseProps) => {
                    if (resp.statusCode === 200) {
                        toast.success("Upload do Excel Concluído!");
                    }
                });
            } else if (file.length > 0 && pag === (years.length - 1))
                await handleUploadProjectHistoryAPI(file[0], company.id, userEmail, false).then((resp: IResponseProps) => {

                    if (resp.statusCode === 200) {
                        toast.success("Upload do Excel Concluído!");
                    }
                });
        }
        catch (err: any) {
            toast.error(err);
        }
        finally {
            toggleLoading(false);
        }

    }

    async function handleDownloadExcelModelBase() {
        try {
            toggleLoading(true);
            await handleDownloadProjectModelAPI().then((response) => {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', SetFileName(company.name, opportunity? opportunity.year.toString() : '', "Projetos", "xlsx"));
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                if (response.statusCode === 200) {
                    toast.success("Download concluído!");
                }
            });
        }
        catch (err: any) {
            toast.error(err);
        }
        finally {
            toggleLoading(false);
        }

    }


    useEffect(() => {
        if (year !== "") {
            if (isCreate) {
                createYear();
            } else {
                deleteYear();
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [year]);

    useEffect(() => {
        if (opportunityMap.length > 0) {
            getYears();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [opportunityMap]);

    useEffect(() => {
        if (opportunityMap.length > 0 && years.length > 0) {
            updateAllValues();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [opportunityMap.length, pag, years]);


    useEffect(() => {
        if (hasChanged) {
            getAllOpportunities();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasChanged]);

    const importProject = async (opportunityId: string) => {
        setOpen(false);
        try {
            toggleLoading(true)
            toast.success("Projetos Importados com Sucesso!");
        } catch (error) {
            console.error('Erro ao importar projetos', error);
            toast.error("Não foi possivel Importar Projetos!")
        } finally {
            toggleLoading(false);
        }


    };
    return (
        <div className='card ml-2 mr-2'>
            {loading && <Loader />}
            <ModalSelectYear
                years={years}
                qtdYearsMinus={3}
                isCreate={isCreate}
                setYear={setYear}
                show={showModal}
                toggleShow={toggleShowModal}
            />

            <CardHeader
                pageName={"Identificação de Projetos"}
                hasPageBefore={false}
            />
            <div className='card-body mt-4'>
                {years.length > 0 ?
                    <div className='pagination-tabs'>
                        <div className="d-flex w-100 align-items-center justify-content-end">
                            {!canNotSee &&
                                <div>
                                    <Button
                                        color="primary"
                                        variant="outlined"
                                        className="bottom-border me-2"
                                        onClick={handleDownloadExcelModelBase}
                                    >
                                        <CloudDownloadOutlined /> Download Modelo
                                    </Button>

                                    <Button
                                        color="primary"
                                        variant="outlined"
                                        className="bottom-border me-2 ms-2"
                                        onClick={toggleExcelModal}
                                    >
                                        <CloudUploadOutlined /> Upload Modelo
                                    </Button>

                                    <Button
                                        color="primary"
                                        variant="outlined"
                                        className="bottom-border ms-2"
                                        onClick={() => {
                                            toggleIsCreate(true);
                                            toggleShowModal();
                                        }}
                                    >
                                        <PlusCircleOutlined /> Acrescentar Ano
                                    </Button>
                                    {/* <Button
                                        variant="contained"
                                        color="info"
                                        className='btn btn-sm btn-secondary button-margin ms-2'
                                        onClick={() => {
                                            toggleIsCreate(false);
                                            toggleShowModal();
                                        }}
                                    >
                                        Remover Ano
                                    </Button> */}
                                </div>
                            }
                        </div>
                        <div className='d-flex align-items-center justify-content-between'>
                            <PaginationTabHeader setPag={setPag} pag={pag} setKey={setKey} keyDefault={key} tabs={SortDesc(years)} />

                        </div>
                        <div className='pagination-tab-body p-3 back-light-projects'>
                            <div className="d-flex w-100 align-items-center justify-content-end">
                                {isItVisible &&
                                    <div className="">
                                        {/* <Button variant="outlined"
                                            color="primary"
                                            style={{
                                                color: '#0000A4',
                                                margin: '10px 0px 0px 0px',
                                                border: '2px solid'
                                            }} onClick={handleOpen}
                                        >
                                            importar projetos do ano anterior
                                        </Button> */}
                                        <Modal
                                            open={open}
                                            onClose={handleClose}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <Box >
                                                <div className="d-flex flex-column align-items-center mt-2 ">
                                                    <Typography id="modal-modal-title" variant="h1" component="h1">
                                                        <h3>Importar Projetos</h3>
                                                    </Typography>
                                                    <Typography id="modal-modal-title" variant="h6" component="h2">
                                                        Selecione os projetos do ano anterior que foram continuados para este ano.
                                                    </Typography>
                                                </div>
                                                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                                    <table className="table table-bordered table-striped table-striped table-bordered table-hover max-widthclass" id="selectFavoritesProjects-table">
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th>Nome do Projeto</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {projects.map((project, index) => (
                                                                <><tr key={index}>
                                                                    <td className="td-check">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                        />
                                                                    </td>
                                                                    <td>{project.name}</td>

                                                                </tr></>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                    <div className='d-flex align-items-center justify-content-end'>
                                                        {projects.length > 0 &&
                                                            <TablePaginationFooter
                                                                totalItems={total}
                                                                change={fetchProjects}
                                                            />
                                                        }
                                                    </div>

                                                    <Button color="primary" variant="outlined" onClick={() => importProject(opportunity?.id.toString() ?? "")}>Importar projetos</Button>


                                                </Typography>
                                            </Box>
                                        </Modal>
                                    </div>
                                }

                            </div>


                            {pag !== (years.length - 1) ?

                                <>
                                    {opportunity &&
                                        <div key={key}>
                                            {/*<InitialInformationsComponent*/}
                                            {/*    opportunity={opportunity}*/}
                                            {/*    toggleLoading={toggleLoading}*/}
                                            {/*    userEmail={userEmail}*/}
                                            {/*    setHasChanged={setHasChanged}*/}
                                            {/*    canNotEdit={canNotSee}*/}
                                            {/*    companyId={company.id}*/}
                                            {/*/>*/}
                                            <ProjectComponent
                                                companyId={company.id}
                                                toggleLoading={toggleLoading}
                                                opportunityId={opportunity.id}
                                                setHasChanged={setHasChanged}
                                                canNotEdit={canNotSee}
                                                setType={setType}
                                            />
                                        </div>
                                    }
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '-1px' }}>
                                        <Button
                                            variant="outlined"
                                            style={{
                                                backgroundColor: "#00AEFF",
                                                color: "#FFFFFF",
                                                fontWeight: "bold",
                                                margin: "10px 10px 20px 0px",
                                                border: "none",
                                                borderRadius: "6px",
                                                padding: "9px 16px",
                                                width: "520px",
                                            }}
                                            onClick={handleOpen}
                                        >
                                            Importar Projetos do Ano Anterior
                                        </Button>
                                    </div>

                                </>
                                :
                                <ProjectHistoryComponent
                                    companyId={company.id}
                                    toggleLoading={toggleLoading}
                                    setHasChanged={setHasChanged}
                                    canNotEdit={canNotSee}
                                />

                            }
                        </div>
                    </div>
                    :
                    !canNotSee ?
                        <Button
                            variant="outlined"
                            color="primary"
                            className='btn btn-primary w-100 mb-3'
                            onClick={() => {
                                toggleIsCreate(true);
                                toggleShowModal();
                            }}
                        >
                            Criar Ano para o Mapeamento de Oportunidades
                        </Button>
                        :
                        <h2 className="text-center">Não há informaçoes no momento!</h2>
                }

            </div>
            <UploadModal
                action={handleUploadProjectInformations}
                icon={IoCodeSlash}
                isShowing={isShowingExcelModal}
                toggle={toggleExcelModal}
                acceptTypes={[".xlsx"]}
                isMultiple={false}
            />
        </div>
    )
}

export default ProjectInformations;